<div [hidden]="!viewCondition" style="margin-top: 16px;">
  @if (pdfSafeUrl != null) {
    <iframe [src]="pdfSafeUrl" width="100%" height="500"></iframe>
  }
</div>

